<!--
 * @Title: 标题
 * @Description: 描述
 * @Author: xulongyong
 * @Date: 2023-09-10 11:12:37
 * @LastEditors: xulongyong
 * @LastEditTime: 2023-09-10 11:14:08
 * @FilePath: \vue-privilege-routing\src\pages\component\credit\index.vue
-->
<template>
    <div>
       积分模组
    </div>
</template>

<script>
export default {
    data() {
        return {}
    }
}
</script>
